export enum ContentType {
  podcast = "podcast",
  video = "video",
  article = "article",
}
